import EventBus from '@/elements/eventBus';
import { mapState } from 'vuex';
import { fetchDownloadLink } from '@/api';
import { prepareURL } from '@/api/httpModule';

export default {
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    async downloadSelectedFiles(fileIds = []) {
      try {
        const {
          data: { id },
        } = await fetchDownloadLink(this.$route.params.id, fileIds);
        this.setDownloadLink(id);
      } catch (error) {
        if (error?.response) {
          this.handleDownloadLinkError(error.response);
        }
      }
    },
    setDownloadLink(id) {
      const url = prepareURL(`/share/download/${id}`);
      if (this.isMobile) {
        window.open(url, '_self');
      } else {
        this.iframeDownload(url);
      }
    },
    handleDownloadLinkError({ status, data }) {
      if (status === 403) {
        if (data.code === 50) {
          this.$notify({
            text: this.$gettext('File infected'),
            type: 'error',
          });
        } else {
          this.$notify({
            text: this.$gettext('These files has been expired. Please contact sender'),
            type: 'error',
          });
        }
      } else if (status === 404) {
        EventBus.$emit('handle-error', {
          response: { status, data },
          options: {
            errorMsg: this.$gettext('The current file cannot be downloaded. Try to refresh the page.'),
          },
        });
      }
    },
    iframeDownload(downloadHash) {
      let iframe = document.getElementById('hiddenDownloader');
      if (iframe === null) {
        iframe = document.createElement('iframe');
        iframe.id = 'hiddenDownloader';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      iframe.src = downloadHash;
    },
  },
};
